import { t } from "i18next";
import { useEffect, useState } from "react";
import { Selector } from "./Selector";

export const ObjectiveSelect = ({
  id = "objective-selector",
  selectedObjective,
  selectedGoal,
  selectedCycle,
  selectHandler,
  trigger,
  setTrigger,
  dashboardGoals,
  size,
}) => {
  const [objectives, setObjectives] = useState([]);

  useEffect(() => {
    if (trigger) {
      setTrigger(false);
      let objectiveOptions = [];
      if (dashboardGoals) {
        dashboardGoals.forEach((goal) => {
          if (goal.id === selectedGoal) {
            goal.objectives.forEach((objective) => {
              objectiveOptions.push({
                id:
                  objective.id === 0
                    ? t("cyclesAndGoals.cycleGoal.objectiveNoneId")
                    : objective.id,
                name: objective.description,
                label: objective.description,
              });
            });
          }
        });
      } else if (selectedGoal && selectedCycle) {
        selectedCycle.goals.forEach((goal) => {
          if (goal.id === selectedGoal) {
            goal.objectives.forEach((objective) => {
              objectiveOptions.push({
                id: objective.id,
                name: objective.description,
                label: objective.description,
              });
            });
          }
        });
        objectiveOptions.unshift({
          id: t("cyclesAndGoals.cycleGoal.objectiveNoneId"),
          name: t("cyclesAndGoals.cycleGoal.objectiveNoneName"),
          label: t("cyclesAndGoals.cycleGoal.objectiveNoneLabel"),
        });
      }
      setObjectives(objectiveOptions);
    }
  }, [selectedCycle, selectedGoal, selectedObjective, trigger]);

  return (
    <Selector
      id={id}
      size={size}
      label={t("cyclesAndGoals.cycleGoal.objectiveTitle")}
      assistiveText={t("cyclesAndGoals.cycleGoal.objectiveAssistiveText")}
      selectHandler={selectHandler}
      options={objectives ? objectives : []}
      selectedItemId={selectedObjective}
      clear={trigger}
    />
  );
};
